import { addRedirectQueryToRoute } from '@chegg-wt/core/utils/routes'
import * as React from 'react'
import { AppLink } from '@chegg-wt/core/components/AppLink'
import { useRoutesContext } from '../../RoutesContext'
import * as Styled from './styled'

export const CONTAINER_ID = 'create-account-callout'
export const LOGIN_LINK_ID = 'create-account-callout-login-link'
export const SIGNUP_LINK_ID = 'create-account-callout-signup-link'

interface Props {
  isLoggedIn: boolean
  projectCount: number
  copy: string
  onUserClickCreateAccountCTA: () => void
  onUserClickSignInCTA: () => void
  showAuthModal: boolean
}

const CreateAccountCallout: React.FC<Props> = ({
  onUserClickCreateAccountCTA,
  onUserClickSignInCTA,
  copy,
  isLoggedIn,
  projectCount,
  showAuthModal,
}) => {
  const { toSignup, toLogin } = useRoutesContext()

  if (isLoggedIn || !!projectCount) {
    return null
  }

  const loginRoute = addRedirectQueryToRoute(toLogin(), window.location.href)
  const signUpRoute = addRedirectQueryToRoute(toSignup(), window.location.href)

  return (
    <Styled.Container data-test={CONTAINER_ID}>
      {showAuthModal ? (
        <Styled.AuthLink onClick={onUserClickCreateAccountCTA} data-test={SIGNUP_LINK_ID}>
          Create an account
        </Styled.AuthLink>
      ) : (
        <AppLink route={signUpRoute}>
          <Styled.Link onClick={onUserClickCreateAccountCTA} data-test={SIGNUP_LINK_ID}>
            Create an account
          </Styled.Link>
        </AppLink>
      )}
      &nbsp;or&nbsp;
      {showAuthModal ? (
        <Styled.AuthLink onClick={onUserClickSignInCTA} data-test={LOGIN_LINK_ID}>
          sign in
        </Styled.AuthLink>
      ) : (
        <AppLink route={loginRoute}>
          <Styled.Link onClick={onUserClickSignInCTA} data-test={LOGIN_LINK_ID}>
            sign in
          </Styled.Link>
        </AppLink>
      )}
      &nbsp;{copy}
    </Styled.Container>
  )
}

export default CreateAccountCallout
